import { Helmet } from "react-helmet-async";
import LandingNavbar from "../../components/LandingNavbar/LandingNavbar";
import TopBanner from "../../components/TopBanner/TopBanner";
import CampaignRequest from "./CampaignRequest/CampaignRequest";
import Location from "./Location/Location";
import Footer from "../../components/Footer/Footer";
import Waitlist from "../../components/Waitlist/Waitlist";

import "./Contact.css";

const Contact = () => {
  return (
    <>

    <Helmet>
  <title>Contact Xyncely | Book a Platform Walkthrough</title>

  <meta
    name="description"
    content="Talk to Xyncely about early access, product walkthroughs, integrations and enterprise requirements for influencer campaign management."
  />

  <meta
    name="robots"
    content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
  />

  <link
    rel="canonical"
    href="https://xyncely.com/contact"
  />

  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Xyncely" />
  <meta property="og:locale" content="en_IN" />

  <meta
    property="og:title"
    content="Contact Xyncely | Book a Platform Walkthrough"
  />

  <meta
    property="og:description"
    content="Talk to Xyncely about early access, product walkthroughs, integrations and enterprise requirements for influencer campaign management."
  />

  <meta
    property="og:url"
    content="https://xyncely.com/contact"
  />

  <meta
    property="og:image"
    content="https://xyncely.com/assets/xyncely-og-1200x630.png"
  />

  <meta property="og:image:type" content="image/png" />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="630" />

  <meta
    property="og:image:alt"
    content="Xyncely - The Command Center for Influencer Marketing"
  />

  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Contact Xyncely | Book a Platform Walkthrough"
  />

  <meta
    name="twitter:description"
    content="Talk to Xyncely about early access, product walkthroughs, integrations and enterprise requirements for influencer campaign management."
  />

  <meta
    name="twitter:image"
    content="https://xyncely.com/assets/xyncely-og-1200x630.png"
  />

  <meta
    name="twitter:image:alt"
    content="Xyncely - The Command Center for Influencer Marketing"
  />
</Helmet>


      <TopBanner />
      <LandingNavbar />

      <main className="contact-page">

        {/* Back to Home */}
        <div className="contact-page__back">
          <a href="/">
            ← <span>Back to Home</span>
          </a>
        </div>

        {/* Contact Hero */}
        <section className="contact-hero">
          <div className="contact-hero__content">

            <div className="contact-hero__eyebrow">
              <span className="contact-hero__icon">♧</span>
              <span>GET IN TOUCH WITH THE BUILDERS</span>
            </div>

            <h1>
              Let's talk <span>campaigns.</span>
            </h1>

            <p>
              Whether you want a personalized platform walkthrough, have
              integration queries, or want to discuss enterprise licensing
              limits.
            </p>

          </div>
        </section>

        {/* Campaign Request Form */}
        <div className="contact-page__main-content">

  <section className="campaign-request-section">
    <Location />
  </section>

  <section className="contact-page__location">
    <CampaignRequest />
  </section>

</div>

{/* Waitlist / Let's Talk section */}
<section className="contact-page__waitlist">
<Waitlist
        eyebrow="LET'S TALK"
        title="We'd love to hear from you"
        description="Whether you're exploring the platform or need a custom solution, our team is ready to help you get started."
        buttonText="Join the Waitlist"
        showProgress={true}
      />
      <Footer/>
</section>

      </main>
    </>
  );
};

export default Contact;